exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.subtitle[data-v-791238b9] {\n  padding-left: 40px;\n  padding-top: 10px;\n  padding-bottom: 15px;\n  color: #999;\n  font-size: 22px;\n}\n", ""]);
